import DocTrack_ from './DocTrack';

export default class QDDocumentsResult {
  Documents: DocTrack_[];

  DocumentsUploadPreHTML: string;

  DocumentsUploadPostHTML: string;
}
